// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PageTooltipFragmentDoc } from '../../../components/layout/tooltip/PageTooltip.fragment.generated';
import { PdpAccordionItemFragmentDoc } from '../../../components/product/PdpAccordion.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.generated';
import { ProductAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { AccentGemFragmentDoc } from '../composables/useAccentGems.generated';
import { ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../components/rings/DeliveryTimeframe.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
import { ReviewsAggregateFragmentDoc } from '../../../components/rings/ReviewsAggregate.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { RelatedProductFragmentDoc } from '../../../components/rings/RelatedProducts.generated';
import { SignatureStoneInputFragmentDoc } from '../../../graphql/api/product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const EngagementRingAndSignatureStoneFragmentDoc = gql`
    fragment engagementRingAndSignatureStone on CatalogueEngagementRingAndSignatureStone {
  salePrice(region: $region, currency: $currency) {
    ...taxSnippet
  }
  signatureStone {
    ...signatureStoneInput
    isDefault
    crystal {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    color {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    image
    price(region: $region, currency: $currency) {
      ...money
    }
  }
}
    ${TaxSnippetFragmentDoc}
${SignatureStoneInputFragmentDoc}
${MoneyFragmentDoc}`;
export const CatalogueEngagementRingFragmentDoc = gql`
    fragment catalogueEngagementRing on CatalogueEngagementRing {
  ...engagementRingLink
  ...productPageMeta
  ...productGallery
  ...productAnalytics
  supportsExpress
  accentGemItems {
    ...accentGem
  }
  isResizeable
  ...shopWithConfidenceProduct
  noEngravingDeliveryDate: firstAvailableDeliveryDate(
    region: $region
    hasEngraving: false
  ) {
    ...deliveryTimeframe
  }
  hasEngravingDeliveryDate: firstAvailableDeliveryDate(
    region: $region
    hasEngraving: true
  ) {
    ...deliveryTimeframe
  }
  reviews {
    ...reviews
  }
  reviewsAggregate {
    ...reviewsAggregate
  }
  catalogueCode
  salePrice(region: $region, currency: $currency) {
    ...taxSnippet
  }
  productName
  variationsByCentreStoneShape {
    ...engagementRingLink
    centreStoneConstraints {
      shape {
        systemCode
        translation(locale: $locale) {
          name
        }
        icon {
          id
          url
        }
      }
    }
  }
  variationsByPrimaryMetal {
    ...metalVariation
    ...engagementRingLink
  }
  bandWidth
  relatedProducts {
    ...relatedProduct
  }
  primaryMetal {
    translation(locale: $locale) {
      name
    }
  }
  translation(locale: $locale) {
    seoText
  }
  centreStoneConstraints {
    shape {
      translation(locale: $locale) {
        name
      }
    }
  }
  signatureStone {
    colors {
      systemCode
    }
    crystal {
      systemCode
    }
    width
  }
  signatureStones {
    ...engagementRingAndSignatureStone
  }
}
    ${EngagementRingLinkFragmentDoc}
${ProductPageMetaFragmentDoc}
${ProductGalleryFragmentDoc}
${ProductAnalyticsFragmentDoc}
${AccentGemFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${ReviewsFragmentDoc}
${ReviewsAggregateFragmentDoc}
${TaxSnippetFragmentDoc}
${MetalVariationFragmentDoc}
${RelatedProductFragmentDoc}
${EngagementRingAndSignatureStoneFragmentDoc}`;
export const EngagementRingPageDocument = gql`
    query engagementRingPage($locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $page: String!, $pageFallback: String!, $engagementRingFilter: CatalogueEngagementRingFilterInput!) {
  catalogueEngagementRing(filter: $engagementRingFilter) {
    ...catalogueEngagementRing
  }
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    priceExplainedTooltip {
      ...pageTooltip
    }
    accordionItems {
      ...pdpAccordionItem
    }
  }
}
    ${CatalogueEngagementRingFragmentDoc}
${BlockFragmentDoc}
${MetaFragmentDoc}
${PageTooltipFragmentDoc}
${PdpAccordionItemFragmentDoc}`;

export function useEngagementRingPageQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.EngagementRingPageQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.EngagementRingPageQuery, SchemaTypes.EngagementRingPageQueryVariables | undefined>({ query: EngagementRingPageDocument, variables: undefined, ...options });
};